import React from 'react';
import TemplateItemList from '../template/TemplateItemList';

const TemplateTab = () => {
  return <TemplateItemList />;
};

export default TemplateTab;